import React from "react";
import { Link } from "react-router-dom";
import { eventCategories } from "../../mock";
import { ArrowUpRight } from "lucide-react";

const EventCategories = ({ title = "Every Celebration Imaginable.", subtitle = "One Platform." }) => {
  return (
    <section className="section bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="text-center mb-14">
          <h2 className="font-serif text-navy-700 text-4xl md:text-5xl lg:text-[56px] leading-tight">
            <span className="italic">{title}</span> {subtitle}
          </h2>
          <p className="mt-5 text-navy-700/70 max-w-2xl mx-auto text-lg">
            One platform for every milestone — weddings, parties, business events, memorials &amp; more.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {eventCategories.map((cat) => (
            <Link key={cat.id} to={cat.href} className="group relative overflow-hidden rounded-2xl aspect-[4/5] block soft-shadow">
              <img src={cat.image} alt={cat.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/80 via-navy-900/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7 flex items-end justify-between text-white">
                <h3 className="font-serif italic text-2xl md:text-3xl">{cat.title}</h3>
                <div className="w-10 h-10 rounded-full bg-white/15 backdrop-blur flex items-center justify-center border border-white/30 group-hover:bg-coral-300 group-hover:border-coral-300 transition-colors">
                  <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventCategories;
